export default "__VITE_ASSET__rWfAYKpj__"